import React from "react";

import {
  SkeletonAvatar,
  SkeletonText,
} from "../../../../../Skeletons/primitives";

/**
 * Candidate detail skeleton components — replaces hardcoded Ant Design
 * Skeleton with SkeletonAvatar + SkeletonText primitives.
 */

// Basic info loader — avatar + name lines
const candidateBasicInfo = ({ size = 90 }) => {
  return (
    <div className="flex !gap-4">
      <div>
        <SkeletonAvatar size={size} shape="circle" />
      </div>
      <div className="mt-[5px] flex flex-col justify-center gap-[6px]">
        <SkeletonText lines={1} widths={["60px"]} size="sm" />
        <SkeletonText lines={1} widths={["200px"]} size="sm" />
      </div>
    </div>
  );
};

// Candidate profile loader — label + value lines
const CandidateRightProfile = ({ SkeletonNumber = 2 }) => {
  const widths = ["50px", "220px", "180px", "150px"];
  return (
    <div className="grid flex-col py-1">
      <SkeletonText
        lines={SkeletonNumber}
        widths={widths.slice(0, SkeletonNumber)}
        size="md"
        gap="6px"
      />
    </div>
  );
};

const CandidateDetailSkeleton = {
  candidateBasicInfo,
  CandidateRightProfile,
};

export default CandidateDetailSkeleton;
